module.exports = __webpack_public_path__ + "static/media/align-left-color.23c94410.svg";